const WASM_BASE =
  (process.env.VITE_TILE_MATCH_WASM_BASE ?? '/wasm/tile-match').replace(/\/$/, '');

type TileMatchAesGcmDecryptFn = (
  packedBase64: string,
  keyBase64: string
) => Promise<string>;

interface TileMatchCryptoGlobal {
  __tileMatchAesGcmDecrypt?: TileMatchAesGcmDecryptFn;
}

function tileMatchCryptoGlobal(): TileMatchCryptoGlobal {
  return globalThis as TileMatchCryptoGlobal;
}

let cryptoHelperLoaded = false;

async function ensureTileMatchCryptoHelper(): Promise<void> {
  const g = tileMatchCryptoGlobal();
  if (cryptoHelperLoaded && g.__tileMatchAesGcmDecrypt) return;
  await import(/* webpackIgnore: true */ `${WASM_BASE}/tile-match-crypto.js`);
  if (!tileMatchCryptoGlobal().__tileMatchAesGcmDecrypt) {
    throw new Error('Tile Match crypto helper failed to load.');
  }
  cryptoHelperLoaded = true;
}

/** Decrypt server bootstrap cipher via Web Crypto (AES-GCM). Returns base64 plaintext for WASM. */
export async function decryptTileMatchBootstrapCipher(
  cipherBase64: string,
  keyBase64: string
): Promise<string> {
  await ensureTileMatchCryptoHelper();
  const decrypt = tileMatchCryptoGlobal().__tileMatchAesGcmDecrypt;
  if (!decrypt) {
    throw new Error('Tile Match crypto helper failed to load.');
  }
  return decrypt(cipherBase64, keyBase64);
}
